module.exports = __webpack_public_path__ + "static/media/search-for-me.91b1b7da.svg";